import React from 'react';

import './spacer.css';

function Spacer() {
  return <div className='util-spacer' />;
}

Spacer.displayName = 'Spacer';

export default Spacer;



// WEBPACK FOOTER //
// ./src/components/util/Spacer.js